import { render, staticRenderFns } from "./DocumentTable.vue?vue&type=template&id=0a4ccd44&scoped=true&"
import script from "./DocumentTable.vue?vue&type=script&lang=ts&"
export * from "./DocumentTable.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentTable.vue?vue&type=style&index=0&id=0a4ccd44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4ccd44",
  null
  
)

export default component.exports